
export default {

};



// WEBPACK FOOTER //
// ./src/store/modules/location/getters.js